// Hub configurations for the 3 new Sur itinerary hubs.
// Each hub renders intro + list of duration options.
// The individual programme detail pages are not built yet — option CTAs land on the contact form.

const COMMON_NIGHTS = {
  "3n4d": { es: "3 noches · 4 días", en: "3 nights · 4 days", fr: "3 nuits · 4 jours" },
  "4n5d": { es: "4 noches · 5 días", en: "4 nights · 5 days", fr: "4 nuits · 5 jours" },
  "5n6d": { es: "5 noches · 6 días", en: "5 nights · 6 days", fr: "5 nuits · 6 jours" },
  "6n7d": { es: "6 noches · 7 días", en: "6 nights · 7 days", fr: "6 nuits · 7 jours" },
  "7n8d": { es: "7 noches · 8 días", en: "7 nights · 8 days", fr: "7 nuits · 8 jours" },
  "8n9d": { es: "8 noches · 9 días", en: "8 nights · 9 days", fr: "8 nuits · 9 jours" },
  "9n10d":{ es: "9 noches · 10 días", en: "9 nights · 10 days", fr: "9 nuits · 10 jours" },
};

export const HUB_ATLAS_DESIERTO = {
  id: "atlas-desierto",
  hero: {
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Ouarzazate · Alto Atlas · Erg Chebbi · Errachidia", en: "Ouarzazate · High Atlas · Erg Chebbi · Errachidia", fr: "Ouarzazate · Haut Atlas · Erg Chebbi · Errachidia" },
    title: { es: "Atlas – Desierto.", en: "Atlas – Desert.", fr: "Atlas – Désert." },
    subtitle: { es: "Cordillera del Atlas y dunas del Erg Chebbi — la travesía clásica del sur.", en: "Atlas range and Erg Chebbi dunes — the classic southern crossing.", fr: "Cordillère de l'Atlas et dunes de l'Erg Chebbi — la traversée classique du sud." },
  },
  intro: {
    overline: { es: "Atlas – Desierto", en: "Atlas – Desert", fr: "Atlas – Désert" },
    title: { es: "De las cumbres del Atlas a las dunas del Sahara.", en: "From Atlas summits to Sahara dunes.", fr: "Des sommets de l'Atlas aux dunes du Sahara." },
    body: {
      es: ["De Ouarzazate al Erg Chebbi atravesando la cordillera del Alto Atlas, sus pueblos imazighen, valles, oasis y gargantas espectaculares."],
      en: ["From Ouarzazate to the Erg Chebbi across the High Atlas range — its Imazighen villages, valleys, oases and spectacular gorges."],
      fr: ["D'Ouarzazate à l'Erg Chebbi à travers la cordillère du Haut Atlas — ses villages imazighen, vallées, oasis et gorges spectaculaires."],
    },
  },
  options: {
    overline: { es: "Opciones de viaje Atlas – Desierto", en: "Atlas – Desert options", fr: "Options Atlas – Désert" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Atlas + Desierto", en: "Atlas + Desert", fr: "Atlas + Désert" },
    group_b: { es: "Desierto + Atlas", en: "Desert + Atlas", fr: "Désert + Atlas" },
  },
  programs: [
    { id: "ad-4-5", direction: "a", nights: "4n5d", accent: "#C16542", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85",
      link: "tourAtlasDesierto45",
      blurb: { es: "Viaje de 4 noches y 5 días por la cordillera del Atlas marroquí y el desierto de dunas del Erg Chebbi en el desierto del Sahara en Marruecos.",
               en: "4-night/5-day journey through the Atlas range and the Erg Chebbi dunes in the Sahara desert.",
               fr: "Voyage de 4 nuits et 5 jours par la cordillère de l'Atlas marocain et les dunes de l'Erg Chebbi dans le Sahara." } },
    { id: "ad-5-6", direction: "a", nights: "5n6d", accent: "#D97742", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourAtlasDesierto56",
      blurb: { es: "Viaje de 5 noches y 6 días por la cordillera del Atlas marroquí y el desierto de dunas del Erg Chebbi en el desierto del Sahara en Marruecos.",
               en: "5-night/6-day journey through the Atlas range and the Erg Chebbi dunes in the Sahara desert.",
               fr: "Voyage de 5 nuits et 6 jours par la cordillère de l'Atlas et les dunes de l'Erg Chebbi dans le Sahara." } },
    { id: "ad-6-7", direction: "a", nights: "6n7d", accent: "#A07042", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85",
      link: "tourAtlasDesierto67",
      blurb: { es: "Viaje de 6 noches y 7 días por la cordillera del Atlas marroquí y el desierto de dunas del Erg Chebbi en el desierto del Sahara en Marruecos.",
               en: "6-night/7-day journey through the Atlas range and the Erg Chebbi dunes in the Sahara desert.",
               fr: "Voyage de 6 nuits et 7 jours par la cordillère de l'Atlas et les dunes de l'Erg Chebbi dans le Sahara." } },
    { id: "da-4-5", direction: "b", nights: "4n5d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas45",
      blurb: { es: "Viaje de 4 noches y 5 días por el desierto de dunas del Erg Chebbi en el desierto del Sáhara y la cordillera del Atlas marroquí.",
               en: "4-night/5-day journey through the Erg Chebbi dunes in the Sahara and the Atlas range.",
               fr: "Voyage de 4 nuits et 5 jours par les dunes de l'Erg Chebbi dans le Sahara et la cordillère de l'Atlas." } },
    { id: "da-5-6", direction: "b", nights: "5n6d", accent: "#7C8B5C", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas56",
      blurb: { es: "Viaje de 5 noches y 6 días por el desierto de dunas del Erg Chebbi en el desierto del Sáhara y la cordillera del Atlas marroquí.",
               en: "5-night/6-day journey through the Erg Chebbi dunes in the Sahara and the Atlas range.",
               fr: "Voyage de 5 nuits et 6 jours par les dunes de l'Erg Chebbi dans le Sahara et la cordillère de l'Atlas." } },
    { id: "da-6-7", direction: "b", nights: "6n7d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas67",
      blurb: { es: "Viaje de 6 noches y 7 días por el desierto de dunas del Erg Chebbi en el desierto del Sáhara y la cordillera del Atlas marroquí.",
               en: "6-night/7-day journey through the Erg Chebbi dunes in the Sahara and the Atlas range.",
               fr: "Voyage de 6 nuits et 7 jours par les dunes de l'Erg Chebbi dans le Sahara et la cordillère de l'Atlas." } },
  ],
};


export const HUB_DESIERTO_ATLAS = {
  id: "desierto-atlas",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Errachidia · Erg Chebbi · Alto Atlas · Ouarzazate", en: "Errachidia · Erg Chebbi · High Atlas · Ouarzazate", fr: "Errachidia · Erg Chebbi · Haut Atlas · Ouarzazate" },
    title: {
      es: "Circuitos combinados Desierto + Atlas.",
      en: "Combined Desert + Atlas circuits.",
      fr: "Circuits combinés Désert + Atlas.",
    },
    subtitle: {
      es: "Empieza en Erfoud, atraviesa el Erg Chebbi y descubre el Alto Atlas marroquí.",
      en: "Start in Erfoud, cross the Erg Chebbi and discover Morocco's High Atlas.",
      fr: "Commencez à Erfoud, traversez l'Erg Chebbi et découvrez le Haut Atlas marocain.",
    },
  },
  intro: {
    overline: { es: "Desierto + Atlas", en: "Desert + Atlas", fr: "Désert + Atlas" },
    title: {
      es: "Una experiencia mágica desde el desierto hasta las cumbres.",
      en: "A magical experience from the desert to the summits.",
      fr: "Une expérience magique du désert aux sommets.",
    },
    body: {
      es: [
        "¿Quieres desconectar unos días y vivir una experiencia mágica? Te proponemos una escapada al desierto de dunas más cercano a Europa: el desierto del Erg Chebbi, en el sur de Marruecos.",
        "Nuestra ruta empieza en Erfoud, ciudad conocida como «la puerta del desierto», donde nos adentraremos en el desierto en un vehículo 4x4 con chófer. Las tradiciones ancestrales de sus gentes, sus mercados, sus colores y una noche bajo las estrellas convertirán nuestra estancia en una experiencia única.",
        "Después continuaremos hacia la cordillera del Alto Atlas, atravesando valles y gargantas, para recorrer algunos poblados Imazighen donde el tiempo parece haberse detenido. Sin duda, será un viaje inolvidable.",
      ],
      en: [
        "Want to disconnect for a few days and live a magical experience? We propose an escape to the dune desert closest to Europe: the Erg Chebbi desert in southern Morocco.",
        "Our route starts in Erfoud, known as «the gate of the desert», where we head into the desert in a 4x4 with driver. The ancestral traditions of its people, its markets, its colours and a night under the stars will turn this trip into a unique experience.",
        "Then we continue towards the High Atlas range, crossing valleys and gorges to explore Imazighen villages where time seems to have stopped. Without doubt, an unforgettable journey.",
      ],
      fr: [
        "Vous voulez déconnecter quelques jours et vivre une expérience magique ? Nous vous proposons une escapade vers le désert de dunes le plus proche d'Europe : le désert de l'Erg Chebbi, dans le sud du Maroc.",
        "Notre itinéraire commence à Erfoud, « la porte du désert », où nous pénétrons dans le désert en 4x4 avec chauffeur. Les traditions ancestrales de ses habitants, ses marchés, ses couleurs et une nuit sous les étoiles transforment ce séjour en une expérience unique.",
        "Nous poursuivons ensuite vers la cordillère du Haut Atlas, en traversant vallées et gorges pour parcourir des villages imazighen où le temps semble s'être arrêté. Sans aucun doute, un voyage inoubliable.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje combinado Desierto + Atlas", en: "Combined Desert + Atlas options", fr: "Options combinées Désert + Atlas" },
    title: {
      es: "Elige tu travesía.",
      en: "Choose your route.",
      fr: "Choisissez votre itinéraire.",
    },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Desierto + Atlas", en: "Desert + Atlas", fr: "Désert + Atlas" },
    group_b: null,
  },
  programs: [
    { id: "da-4-5", direction: "a", nights: "4n5d", accent: "#5A6B4F",
      image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas45",
      blurb: { es: "Viaje de 4 noches y 5 días por el desierto y el Atlas de Marruecos.",
               en: "4-night/5-day journey through the desert and the Atlas of Morocco.",
               fr: "Voyage de 4 nuits et 5 jours par le désert et l'Atlas du Maroc." } },
    { id: "da-5-6", direction: "a", nights: "5n6d", accent: "#7C8B5C",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas56",
      blurb: { es: "Viaje de 5 noches y 6 días por el desierto y el Atlas de Marruecos.",
               en: "5-night/6-day journey through the desert and the Atlas of Morocco.",
               fr: "Voyage de 5 nuits et 6 jours par le désert et l'Atlas du Maroc." } },
    { id: "da-6-7", direction: "a", nights: "6n7d", accent: "#3A4A5F",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourDesiertoAtlas67",
      blurb: { es: "Viaje de 6 noches y 7 días por el desierto y el Atlas de Marruecos.",
               en: "6-night/7-day journey through the desert and the Atlas of Morocco.",
               fr: "Voyage de 6 nuits et 7 jours par le désert et l'Atlas du Maroc." } },
  ],
};


export const HUB_MARRAKECH_ERG = {
  id: "marrakech-erg",
  hero: {
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Marrakech · Atlas · Erg Chebbi", en: "Marrakech · Atlas · Erg Chebbi", fr: "Marrakech · Atlas · Erg Chebbi" },
    title: {
      es: "Marrakech – Erg Chebbi.",
      en: "Marrakech – Erg Chebbi.",
      fr: "Marrakech – Erg Chebbi.",
    },
    subtitle: {
      es: "De la ciudad roja a las dunas más cercanas a Europa — el alma del sur de Marruecos en una sola ruta.",
      en: "From the red city to Europe's closest dunes — the soul of southern Morocco on one route.",
      fr: "De la ville rouge aux dunes les plus proches de l'Europe — l'âme du sud du Maroc en un seul itinéraire.",
    },
  },
  intro: {
    overline: { es: "Marrakech – Erg Chebbi", en: "Marrakech – Erg Chebbi", fr: "Marrakech – Erg Chebbi" },
    title: { es: "Un viaje auténtico para conocer el sur.", en: "An authentic journey through the south.", fr: "Un voyage authentique pour découvrir le sud." },
    body: {
      es: [
        "Marrakech – Erg Chebbi es un viaje de lo más auténtico para conocer el sur del país.",
        "Esta ruta nos despierta en Marrakech, una ciudad llena de colores, salpicada de artesanos y artistas, de plazas maravillosas, de aromas que marcarán nuestro recuerdo.",
        "De la ciudad, saldremos con un 4x4 hacia el Alto Atlas, descubriendo los paisajes a nuestro paso, deteniéndonos a contemplar su belleza, a conversar con los aldeanos, a disfrutar sin prisas de sus pueblos perdidos, de sus gargantas inmensas.",
        "Dejaremos atrás las montañas para llegar al Desierto del Erg Chebbi, un espectáculo para los sentidos: interminables dunas y ese halo que desprenden los lugares mágicos nos permitirá pasar una noche inolvidable bajo las estrellas.",
        "El camino nos lleva por lugares tan originales como los poblados de Rissani, con su mercado ancestral entre muchos otros…",
      ],
      en: [
        "Marrakech – Erg Chebbi is one of the most authentic journeys to uncover the south of the country.",
        "The route wakes us up in Marrakech, a city full of colour, sprinkled with artisans and artists, with marvellous squares and aromas that will mark our memory.",
        "From the city we set off by 4x4 to the High Atlas, discovering the landscapes along the way, stopping to admire their beauty, to chat with villagers, to enjoy unhurried the forgotten villages and the vast gorges.",
        "We leave the mountains behind to reach the Erg Chebbi Desert — a feast for the senses: endless dunes and the halo of magical places will let us spend an unforgettable night under the stars.",
        "The road takes us through places as original as the village of Rissani with its ancestral market and many others…",
      ],
      fr: [
        "Marrakech – Erg Chebbi est l'un des voyages les plus authentiques pour découvrir le sud du pays.",
        "L'itinéraire nous réveille à Marrakech, ville pleine de couleurs, parsemée d'artisans et d'artistes, aux places merveilleuses, aux parfums qui marqueront notre mémoire.",
        "Depuis la ville, nous partons en 4x4 vers le Haut Atlas, découvrant les paysages au fil de la route, s'arrêtant pour contempler leur beauté, parler avec les villageois, savourer sans hâte ses villages perdus et ses gorges immenses.",
        "Nous laissons les montagnes derrière nous pour atteindre le désert de l'Erg Chebbi, un spectacle pour les sens : dunes infinies et halo magique pour une nuit inoubliable sous les étoiles.",
        "La route nous emmène par des lieux aussi originaux que Rissani et son marché ancestral, parmi tant d'autres…",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje Marrakech – Erg Chebbi", en: "Marrakech – Erg Chebbi options", fr: "Options Marrakech – Erg Chebbi" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Marrakech → Erg Chebbi", en: "Marrakech → Erg Chebbi", fr: "Marrakech → Erg Chebbi" },
    group_b: { es: "Erg Chebbi → Marrakech", en: "Erg Chebbi → Marrakech", fr: "Erg Chebbi → Marrakech" },
  },
  oppositeHub: {
    routeId: "tourErgChebbiMarrakechHub",
    label: {
      es: "Solo sentido inverso · Erg Chebbi → Marrakech",
      en: "Reverse direction only · Erg Chebbi → Marrakech",
      fr: "Sens inverse uniquement · Erg Chebbi → Marrakech",
    },
  },
  programs: [
    { id: "me-4-5", direction: "a", nights: "4n5d", accent: "#C16542",
      image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechErg45",
      blurb: { es: "Viaje de 4 noches y 5 días desde Marrakech hasta el desierto del Erg Chebbi.",
               en: "4-night/5-day journey from Marrakech to the Erg Chebbi desert.",
               fr: "Voyage de 4 nuits et 5 jours de Marrakech au désert de l'Erg Chebbi." } },
    { id: "me-5-6", direction: "a", nights: "5n6d", accent: "#D97742",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechErg56",
      blurb: { es: "Viaje de 5 noches y 6 días desde Marrakech hasta el desierto del Erg Chebbi.",
               en: "5-night/6-day journey from Marrakech to the Erg Chebbi desert.",
               fr: "Voyage de 5 nuits et 6 jours de Marrakech au désert de l'Erg Chebbi." } },
    { id: "me-6-7", direction: "a", nights: "6n7d", accent: "#A07042",
      image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechErg67",
      blurb: { es: "Viaje de 6 noches y 7 días desde Marrakech hasta el desierto del Erg Chebbi.",
               en: "6-night/7-day journey from Marrakech to the Erg Chebbi desert.",
               fr: "Voyage de 6 nuits et 7 jours de Marrakech au désert de l'Erg Chebbi." } },
    { id: "me-7-8", direction: "a", nights: "7n8d", accent: "#D4A373",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechErg78",
      blurb: { es: "Viaje de 7 noches y 8 días desde Marrakech hasta el desierto del Erg Chebbi.",
               en: "7-night/8-day journey from Marrakech to the Erg Chebbi desert.",
               fr: "Voyage de 7 nuits et 8 jours de Marrakech au désert de l'Erg Chebbi." } },
    { id: "em-4-5", direction: "b", nights: "4n5d", accent: "#5A6B4F",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech45",
      blurb: { es: "Viaje de 4 noches y 5 días desde Errachidia hasta Marrakech.",
               en: "4-night/5-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 4 nuits et 5 jours d'Errachidia à Marrakech." } },
    { id: "em-5-6", direction: "b", nights: "5n6d", accent: "#7C8B5C",
      image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech56",
      blurb: { es: "Viaje de 5 noches y 6 días desde Errachidia hasta Marrakech.",
               en: "5-night/6-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 5 nuits et 6 jours d'Errachidia à Marrakech." } },
    { id: "em-6-7", direction: "b", nights: "6n7d", accent: "#A07042",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech67",
      blurb: { es: "Viaje de 6 noches y 7 días desde Errachidia hasta Marrakech.",
               en: "6-night/7-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 6 nuits et 7 jours d'Errachidia à Marrakech." } },
    { id: "em-7-8", direction: "b", nights: "7n8d", accent: "#3A4A5F",
      image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech78",
      blurb: { es: "Viaje de 7 noches y 8 días desde Errachidia hasta Marrakech.",
               en: "7-night/8-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 7 nuits et 8 jours d'Errachidia à Marrakech." } },
  ],
};

/* ============================================================
   HUB · Erg Chebbi → Marrakech
   Reverse-direction hub: same 4 durations as MARRAKECH_ERG but
   only the desert-first variants are presented, with their own
   intro copy and place chips.
============================================================ */
export const HUB_ERGCHEBBI_MARRAKECH = {
  id: "ergchebbi-marrakech",
  hero: {
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Erg Chebbi · Atlas · Marrakech", en: "Erg Chebbi · Atlas · Marrakech", fr: "Erg Chebbi · Atlas · Marrakech" },
    title: {
      es: "Erg Chebbi – Marrakech.",
      en: "Erg Chebbi – Marrakech.",
      fr: "Erg Chebbi – Marrakech.",
    },
    subtitle: {
      es: "De las dunas del Sahara a la ciudad roja — el sur de Marruecos en dirección inversa, empezando por una noche bajo las estrellas.",
      en: "From the Sahara dunes to the red city — southern Morocco in reverse, starting with a night under the stars.",
      fr: "Des dunes du Sahara à la ville rouge — le sud du Maroc en sens inverse, en commençant par une nuit sous les étoiles.",
    },
  },
  intro: {
    overline: { es: "Erg Chebbi – Marrakech", en: "Erg Chebbi – Marrakech", fr: "Erg Chebbi – Marrakech" },
    title: {
      es: "Un viaje auténtico para conocer el sur.",
      en: "An authentic journey through the south.",
      fr: "Un voyage authentique pour découvrir le sud.",
    },
    body: {
      es: [
        "«Erg Chebbi – Marrakech» es un viaje de lo más auténtico para conocer el sur del país.",
        "Esta ruta nos despierta en el Desierto del Erg Chebbi, un espectáculo para los sentidos, con interminables dunas y ese halo que desprenden los lugares mágicos. Nos permitirá pasar una noche inolvidable bajo las estrellas.",
        "Seguiremos con nuestro vehículo 4x4 hacia el Alto Atlas, descubriendo los paisajes a nuestro paso, deteniéndonos a contemplar su belleza, a conversar con los aldeanos y a disfrutar sin prisas de sus pueblos perdidos y de sus gargantas inmensas.",
        "La ruta finalizará en Marrakech, una ciudad llena de colores, salpicada de artesanos y artistas, de plazas maravillosas y de aromas que marcarán nuestro recuerdo.",
      ],
      en: [
        "«Erg Chebbi – Marrakech» is one of the most authentic journeys to discover the south of the country.",
        "The route wakes us up in the Erg Chebbi desert, a feast for the senses with endless dunes and the halo of magical places. It lets us spend an unforgettable night under the stars.",
        "We then continue by 4x4 to the High Atlas, discovering the landscapes along the way, stopping to admire their beauty, to chat with villagers and to enjoy — without rush — its forgotten hamlets and immense gorges.",
        "The route ends in Marrakech, a city full of colour, scattered with artisans and artists, with marvellous squares and aromas that will mark our memory.",
      ],
      fr: [
        "« Erg Chebbi – Marrakech » est l'un des voyages les plus authentiques pour découvrir le sud du pays.",
        "L'itinéraire nous réveille dans le désert de l'Erg Chebbi, un spectacle pour les sens, avec ses dunes infinies et ce halo magique propre aux lieux d'exception — pour une nuit inoubliable sous les étoiles.",
        "Nous poursuivons en 4x4 vers le Haut Atlas, en découvrant les paysages, en discutant avec les villageois et en savourant sans hâte les villages perdus et les gorges immenses.",
        "L'itinéraire s'achève à Marrakech, ville colorée parsemée d'artisans et d'artistes, aux places merveilleuses et aux parfums qui marqueront notre mémoire.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje Erg Chebbi – Marrakech", en: "Erg Chebbi – Marrakech options", fr: "Options Erg Chebbi – Marrakech" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    // Single direction → we hide the direction groups
    group_a: null,
    group_b: null,
  },
  oppositeHub: {
    routeId: "tourMarrakechErgHub",
    label: {
      es: "Ver sentido inverso · Marrakech → Erg Chebbi",
      en: "See reverse direction · Marrakech → Erg Chebbi",
      fr: "Voir le sens inverse · Marrakech → Erg Chebbi",
    },
  },
  programs: [
    { id: "em-4-5", nights: "4n5d", accent: "#5A6B4F",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech45",
      blurb: { es: "Viaje de 4 noches y 5 días desde Errachidia hasta Marrakech.",
               en: "4-night/5-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 4 nuits et 5 jours d'Errachidia à Marrakech." } },
    { id: "em-5-6", nights: "5n6d", accent: "#7C8B5C",
      image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech56",
      blurb: { es: "Viaje de 5 noches y 6 días desde Errachidia hasta Marrakech.",
               en: "5-night/6-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 5 nuits et 6 jours d'Errachidia à Marrakech." } },
    { id: "em-6-7", nights: "6n7d", accent: "#A07042",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech67",
      blurb: { es: "Viaje de 6 noches y 7 días desde Errachidia hasta Marrakech.",
               en: "6-night/7-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 6 nuits et 7 jours d'Errachidia à Marrakech." } },
    { id: "em-7-8", nights: "7n8d", accent: "#3A4A5F",
      image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85",
      link: "tourErgMarrakech78",
      blurb: { es: "Viaje de 7 noches y 8 días desde Errachidia hasta Marrakech.",
               en: "7-night/8-day journey from Errachidia to Marrakech.",
               fr: "Voyage de 7 nuits et 8 jours d'Errachidia à Marrakech." } },
  ],
};

export const HUB_MARRAKECH_LOOP = {
  id: "marrakech-loop",
  hero: {
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Marrakech · Atlas · Erg Chebbi · Marrakech", en: "Marrakech · Atlas · Erg Chebbi · Marrakech", fr: "Marrakech · Atlas · Erg Chebbi · Marrakech" },
    title: {
      es: "Marrakech – Erg Chebbi – Marrakech.",
      en: "Marrakech – Erg Chebbi – Marrakech.",
      fr: "Marrakech – Erg Chebbi – Marrakech.",
    },
    subtitle: {
      es: "Una ruta circular para descubrir en profundidad el sur de Marruecos saliendo y regresando a la ciudad roja.",
      en: "A circular route to discover southern Morocco in depth, leaving from and returning to the red city.",
      fr: "Un itinéraire circulaire pour découvrir en profondeur le sud du Maroc, au départ et au retour de la ville rouge.",
    },
  },
  intro: {
    overline: { es: "Marrakech – Erg Chebbi – Marrakech", en: "Marrakech – Erg Chebbi – Marrakech", fr: "Marrakech – Erg Chebbi – Marrakech" },
    title: { es: "Circular por el corazón del sur.", en: "A loop through the heart of the south.", fr: "Une boucle au cœur du sud." },
    body: {
      es: [
        "Marrakech – Erg Chebbi – Marrakech es una ruta diseñada para descubrir en profundidad el sur de Marruecos.",
        "El viaje comienza en Marrakech y continúa atravesando el Alto Atlas en vehículo 4x4, recorriendo pueblos bereberes, valles, oasis y gargantas espectaculares.",
        "La ruta permite disfrutar del paisaje sin prisas, conversar con aldeanos locales y descubrir el ritmo auténtico del Marruecos más tradicional.",
        "El desierto del Erg Chebbi ofrece una de las experiencias más memorables del viaje: una noche bajo las estrellas rodeados de dunas infinitas y silencio absoluto, antes de regresar a Marrakech.",
      ],
      en: [
        "Marrakech – Erg Chebbi – Marrakech is a circular route designed to discover southern Morocco in depth.",
        "The journey starts in Marrakech and continues across the High Atlas by 4x4, threading Berber villages, valleys, oases and spectacular gorges.",
        "The route lets you enjoy the landscape unhurried, chat with local villagers and discover the authentic rhythm of traditional Morocco.",
        "The Erg Chebbi desert delivers one of the most memorable moments of the trip: a night under the stars surrounded by endless dunes and absolute silence, before returning to Marrakech.",
      ],
      fr: [
        "Marrakech – Erg Chebbi – Marrakech est un itinéraire circulaire conçu pour découvrir en profondeur le sud du Maroc.",
        "Le voyage débute à Marrakech et continue à travers le Haut Atlas en 4x4, traversant villages berbères, vallées, oasis et gorges spectaculaires.",
        "L'itinéraire permet de profiter du paysage sans hâte, de discuter avec les villageois et de découvrir le rythme authentique du Maroc traditionnel.",
        "Le désert de l'Erg Chebbi offre l'un des moments les plus mémorables du voyage : une nuit sous les étoiles entouré de dunes infinies et d'un silence absolu, avant de regagner Marrakech.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje Marrakech – Erg Chebbi – Marrakech", en: "Marrakech loop options", fr: "Options Marrakech – Erg Chebbi – Marrakech" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Marrakech → Erg Chebbi → Marrakech", en: "Marrakech → Erg Chebbi → Marrakech", fr: "Marrakech → Erg Chebbi → Marrakech" },
  },
  programs: [
    { id: "mem-2-3", direction: "a", nights: "2n3d", accent: "#5A6B4F",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop23",
      blurb: { es: "Escapada de 2 noches y 3 días desde Marrakech al desierto del Erg Chebbi y vuelta a Marrakech.",
               en: "Short 2-night/3-day escape from Marrakech to the Erg Chebbi desert and back to Marrakech.",
               fr: "Escapade courte de 2 nuits et 3 jours de Marrakech au désert de l'Erg Chebbi et retour à Marrakech." } },
    { id: "mem-3-4", direction: "a", nights: "3n4d", accent: "#7C8B5C",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop34",
      blurb: { es: "Escapada de 3 noches y 4 días desde Marrakech al desierto del Erg Chebbi, con noche extra en Kasbah Xaluca.",
               en: "3-night/4-day escape from Marrakech to the Erg Chebbi desert, with an extra night at Kasbah Xaluca.",
               fr: "Escapade de 3 nuits et 4 jours de Marrakech au désert de l'Erg Chebbi, avec une nuit supplémentaire au Kasbah Xaluca." } },
    { id: "mem-4-5", direction: "a", nights: "4n5d", accent: "#D97742",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop45",
      blurb: { es: "Escapada de 4 noches y 5 días desde Marrakech con día completo en el Alto Atlas Central y dos noches en Kasbah Xaluca.",
               en: "4-night/5-day escape from Marrakech with a full Central High Atlas day and two nights at Kasbah Xaluca.",
               fr: "Escapade de 4 nuits et 5 jours depuis Marrakech avec une journée complète dans le Haut Atlas Central et deux nuits au Kasbah Xaluca." } },
    { id: "mem-5-6", direction: "a", nights: "5n6d", accent: "#C16542",
      image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop56",
      blurb: { es: "Circuito completo de 5 noches y 6 días con dos noches en Marrakech, visita guiada a la Medina y bivouac en el Erg Chebbi.",
               en: "Full 5-night/6-day circuit with two nights in Marrakech, guided Medina tour and Erg Chebbi bivouac.",
               fr: "Circuit complet de 5 nuits et 6 jours avec deux nuits à Marrakech, visite guidée de la Médina et bivouac à l'Erg Chebbi." } },
    { id: "mem-6-7", direction: "a", nights: "6n7d", accent: "#D97742",
      image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop67",
      blurb: { es: "Viaje de 6 noches y 7 días desde Marrakech hasta el desierto del Erg Chebbi y de vuelta a Marrakech.",
               en: "6-night/7-day journey from Marrakech to the Erg Chebbi desert and back to Marrakech.",
               fr: "Voyage de 6 nuits et 7 jours de Marrakech au désert de l'Erg Chebbi et retour à Marrakech." } },
    { id: "mem-7-8", direction: "a", nights: "7n8d", accent: "#A07042",
      image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechLoop78",
      blurb: { es: "Viaje de 7 noches y 8 días desde Marrakech hasta el desierto del Erg Chebbi y de vuelta a Marrakech.",
               en: "7-night/8-day journey from Marrakech to the Erg Chebbi desert and back to Marrakech.",
               fr: "Voyage de 7 nuits et 8 jours de Marrakech au désert de l'Erg Chebbi et retour à Marrakech." } },
  ],
};

export const HUB_MARRAKECH_ESSAOUIRA = {
  id: "marrakech-essaouira",
  hero: {
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Marrakech · Essaouira", en: "Marrakech · Essaouira", fr: "Marrakech · Essaouira" },
    title: {
      es: "Marrakech – Essaouira.",
      en: "Marrakech – Essaouira.",
      fr: "Marrakech – Essaouira.",
    },
    subtitle: {
      es: "De la ciudad roja a la perla del Atlántico — un combinado entre dos lugares imprescindibles de Marruecos.",
      en: "From the red city to the Atlantic pearl — a pairing of two Moroccan essentials.",
      fr: "De la ville rouge à la perle de l'Atlantique — une combinaison de deux incontournables du Maroc.",
    },
  },
  intro: {
    overline: { es: "Marrakech – Essaouira – Marrakech", en: "Marrakech – Essaouira – Marrakech", fr: "Marrakech – Essaouira – Marrakech" },
    title: { es: "Dos almas, un mismo viaje.", en: "Two souls, one journey.", fr: "Deux âmes, un seul voyage." },
    body: {
      es: [
        "Te presentamos un combinado entre dos lugares imprescindibles en Marruecos.",
        "Por un lado, la famosísima Marrakech, con su inigualable Plaza Djemaa el Fna, su gran Zoco donde perderse en sus bulliciosas callejuelas repletas de palacios y jardines, talleres de artesanía y locales de última moda.",
        "Por otro lado Essaouira «la Perla del Atlántico». Una bella población de pescadores donde pasear, relajarse… también declarada Patrimonio de la Humanidad por la Unesco.",
      ],
      en: [
        "A two-city pairing of two essentials of Morocco.",
        "On one hand, the famous Marrakech, with its unrivalled Jemaa el-Fna square and grand souk to get lost in — bustling alleys filled with palaces, gardens, artisan workshops and trendy boutiques.",
        "On the other hand Essaouira, «the Pearl of the Atlantic». A beautiful fishing town to stroll and relax — also a UNESCO World Heritage site.",
      ],
      fr: [
        "Une combinaison de deux incontournables du Maroc.",
        "D'un côté la célèbre Marrakech, avec son incomparable place Jemaa el-Fna et son grand souk où se perdre — ruelles animées remplies de palais, jardins, ateliers d'artisans et boutiques tendance.",
        "De l'autre Essaouira « la Perle de l'Atlantique » — ravissante ville de pêcheurs où flâner et se détendre, également classée Patrimoine Mondial de l'UNESCO.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje Marrakech – Essaouira – Marrakech", en: "Marrakech – Essaouira options", fr: "Options Marrakech – Essaouira" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Marrakech ↔ Essaouira", en: "Marrakech ↔ Essaouira", fr: "Marrakech ↔ Essaouira" },
  },
  programs: [
    { id: "mes-4-5", direction: "a", nights: "4n5d", accent: "#3A4A5F",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechEss45",
      blurb: { es: "Viaje de 4 noches y 5 días desde Marrakech hasta Essaouira.",
               en: "4-night/5-day journey from Marrakech to Essaouira.",
               fr: "Voyage de 4 nuits et 5 jours de Marrakech à Essaouira." } },
    { id: "mes-6-7", direction: "a", nights: "6n7d", accent: "#5A7F9C",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourMarrakechEss67",
      blurb: { es: "Viaje de 6 noches y 7 días desde Marrakech hasta Essaouira.",
               en: "6-night/7-day journey from Marrakech to Essaouira.",
               fr: "Voyage de 6 nuits et 7 jours de Marrakech à Essaouira." } },
  ],
};

export const HUB_ERRACHIDIA_ATLAS_FEZ = {
  id: "errachidia-atlas-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    place: { es: "Errachidia · Alto Atlas · Fez", en: "Errachidia · High Atlas · Fez", fr: "Errachidia · Haut Atlas · Fès" },
    title: {
      es: "Errachidia – Alto Atlas – Fez.",
      en: "Errachidia – High Atlas – Fez.",
      fr: "Errachidia – Haut Atlas – Fès.",
    },
    subtitle: {
      es: "Del oasis del Tafilalet al alma medieval de Fez, atravesando los pasos más altos del Atlas marroquí.",
      en: "From the Tafilalet oasis to the medieval soul of Fez, crossing Morocco's highest Atlas passes.",
      fr: "De l'oasis du Tafilalet à l'âme médiévale de Fès, en traversant les plus hauts cols de l'Atlas marocain.",
    },
  },
  intro: {
    overline: { es: "Errachidia · Alto Atlas · Fez", en: "Errachidia · High Atlas · Fez", fr: "Errachidia · Haut Atlas · Fès" },
    title: {
      es: "Dos viajes posibles, una misma travesía.",
      en: "Two possible journeys, one same crossing.",
      fr: "Deux voyages possibles, une même traversée.",
    },
    body: {
      es: [
        "Descubre Errachidia, un destino cautivador situado en las impresionantes montañas del Alto Atlas de Marruecos, con la autenticidad y la serenidad que se respiran en medio de estos paisajes.",
        "Finalmente, adéntrate en Fez, con sus laberínticas calles medievales y su fascinante mezcla de historia y cultura, donde cada rincón cuenta una historia milenaria.",
        "Esta combinación única de destinos te transportará a través de los contrastes y la diversidad de Marruecos, ofreciéndote una experiencia inolvidable que cautivará todos tus sentidos.",
      ],
      en: [
        "Discover Errachidia, a captivating destination at the foot of Morocco's stunning High Atlas mountains, with the authenticity and serenity that breathe through these landscapes.",
        "Then immerse yourself in Fez, with its labyrinthine medieval streets and its fascinating blend of history and culture, where every corner tells a thousand-year-old story.",
        "This unique combination of destinations will take you across the contrasts and diversity of Morocco — an unforgettable experience that will captivate all your senses.",
      ],
      fr: [
        "Découvrez Errachidia, destination captivante au pied du majestueux Haut Atlas marocain, avec l'authenticité et la sérénité qui se dégagent de ces paysages.",
        "Puis plongez dans Fès, ses ruelles médiévales labyrinthiques et son fascinant mélange d'histoire et de culture, où chaque coin raconte une histoire millénaire.",
        "Cette combinaison unique de destinations vous fera traverser les contrastes et la diversité du Maroc — une expérience inoubliable qui captivera tous vos sens.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje", en: "Trip options", fr: "Options de voyage" },
    title: {
      es: "Elige tu dirección.",
      en: "Choose your direction.",
      fr: "Choisissez votre direction.",
    },
    body: {
      es: "Dependiendo de dónde prefieras comenzar tu viaje, selecciona entre las dos opciones disponibles según los días que tengas disponibles.",
      en: "Pick where you'd rather start your journey, between the two available options depending on the days you have.",
      fr: "Selon l'endroit où vous préférez commencer votre voyage, choisissez entre les deux options disponibles selon les jours dont vous disposez.",
    },
    group_a: { es: "Errachidia → Atlas → Fez", en: "Errachidia → Atlas → Fez", fr: "Errachidia → Atlas → Fès" },
    group_b: { es: "Fez → Atlas → Errachidia", en: "Fez → Atlas → Errachidia", fr: "Fès → Atlas → Errachidia" },
  },
  programs: [
    { id: "eaf-5-6", direction: "a", nights: "5n6d", accent: "#C16542",
      image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85",
      link: "tourErrAtlasFez56",
      blurb: { es: "Viaje de 5 noches y 6 días desde Errachidia hasta Fez.",
               en: "5-night/6-day journey from Errachidia to Fez.",
               fr: "Voyage de 5 nuits et 6 jours d'Errachidia à Fès." } },
    { id: "fae-5-6", direction: "b", nights: "5n6d", accent: "#5A7F9C",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourFezAtlasErr56",
      blurb: { es: "Viaje de 5 noches y 6 días desde Fez hasta Errachidia.",
               en: "5-night/6-day journey from Fez to Errachidia.",
               fr: "Voyage de 5 nuits et 6 jours de Fès à Errachidia." } },
  ],
};



export { COMMON_NIGHTS };

/* ============================================================
   /viajes/gransur/* — Hubs intermedios desde la página
   /viajes/marruecos (Gran Sur de Marruecos).
   Cada hub muestra opciones de duración agrupadas por dirección.
============================================================ */

const T = (es, en, fr) => ({ es, en, fr });
const BLURB_FR = (n, d) => (origen, destino) => T(
  `Viaje de ${n} noches y ${d} días desde ${origen} hasta ${destino}.`,
  `${n}-night/${d}-day journey from ${origen} to ${destino}.`,
  `Voyage de ${n} nuits et ${d} jours de ${origen} à ${destino}.`,
);
const BLURB_SIDI = (n, d) => (origen, destino) => T(
  `Viaje de ${n} noches y ${d} días desde ${origen} hasta ${destino} pasando por el lago Aguelmame Sidi Ali.`,
  `${n}-night/${d}-day journey from ${origen} to ${destino} via the Aguelmame Sidi Ali lake.`,
  `Voyage de ${n} nuits et ${d} jours de ${origen} à ${destino} en passant par le lac Aguelmame Sidi Ali.`,
);
const BLURB_KASBAH = (n, d) => (origen, destino) => T(
  `Viaje de ${n} noches y ${d} días desde ${origen} hasta ${destino} recorriendo la ruta de las mil kasbahs.`,
  `${n}-night/${d}-day journey from ${origen} to ${destino} along the route of a thousand kasbahs.`,
  `Voyage de ${n} nuits et ${d} jours de ${origen} à ${destino} par la route des mille kasbahs.`,
);

export const HUB_GRANSUR_FEZ_RAK = {
  id: "gransur-fez-rak",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes por todo Marruecos", "Journeys across Morocco", "Voyages à travers le Maroc"),
    place: T("Fez · Atlas · Erg Chebbi · Marrakech", "Fez · Atlas · Erg Chebbi · Marrakech", "Fès · Atlas · Erg Chebbi · Marrakech"),
    title: T("Gran Sur · Fez – Marrakech.", "Grand South · Fez – Marrakech.", "Grand Sud · Fès – Marrakech."),
    subtitle: T(
      "De la medina más antigua del mundo árabe a la ciudad roja — el sur de Marruecos en una sola travesía.",
      "From the oldest medina in the Arab world to the red city — southern Morocco in one crossing.",
      "De la plus ancienne médina du monde arabe à la ville rouge — le sud du Maroc en une seule traversée.",
    ),
  },
  intro: {
    overline: T("Gran Sur · Fez – Marrakech", "Grand South · Fez – Marrakech", "Grand Sud · Fès – Marrakech"),
    title: T("Una travesía cinematográfica del norte imperial al sur sahariano.", "A cinematic crossing from the imperial north to the Saharan south.", "Une traversée cinématographique du nord impérial au sud saharien."),
    body: {
      es: [
        "Gran Sur · Fez – Marrakech es la travesía clásica para descubrir lo mejor de Marruecos en un solo viaje.",
        "La ruta arranca en Fez, cuya medina patrimonio UNESCO es el laberinto vivo más fascinante del mundo árabe, y cruza el Medio Atlas con sus bosques de cedros y sus pueblos bereberes.",
        "Desde Erfoud nos adentramos en el Erg Chebbi, un mar de dunas de 150 metros, donde dormiremos en bivouac de lujo bajo un cielo absolutamente estrellado.",
        "Tras la ruta de las mil kasbahs y el imponente Aït Benhaddou, atravesaremos el Alto Atlas por el puerto de Tizi n'Tichka para terminar en Marrakech, la ciudad roja.",
      ],
      en: [
        "Grand South · Fez – Marrakech is the classic crossing to discover the best of Morocco in a single journey.",
        "The route starts in Fez — its UNESCO medina is the most fascinating living labyrinth in the Arab world — and crosses the Middle Atlas with its cedar forests and Berber villages.",
        "From Erfoud we enter the Erg Chebbi, a sea of 150-metre dunes, sleeping in a luxury bivouac under an absolute starry sky.",
        "After the route of a thousand kasbahs and the imposing Aït Benhaddou, we cross the High Atlas via the Tizi n'Tichka pass to finish in Marrakech, the red city.",
      ],
      fr: [
        "Grand Sud · Fès – Marrakech est la traversée classique pour découvrir le meilleur du Maroc en un seul voyage.",
        "L'itinéraire débute à Fès — sa médina UNESCO est le labyrinthe vivant le plus fascinant du monde arabe — et traverse le Moyen Atlas avec ses forêts de cèdres et ses villages berbères.",
        "Depuis Erfoud, nous entrons dans l'Erg Chebbi, une mer de dunes de 150 mètres, pour dormir en bivouac de luxe sous un ciel étoilé absolu.",
        "Après la route des mille kasbahs et l'imposant Aït Benhaddou, nous traversons le Haut Atlas par le col Tizi n'Tichka pour terminer à Marrakech, la ville rouge.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje del Gran Sur de Marruecos desde Fez hasta Marrakech", "Grand South of Morocco options from Fez to Marrakech", "Options Grand Sud du Maroc, de Fès à Marrakech"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on how many days you have for this journey.",
      "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    ),
    group_a: T("Fez → Marrakech", "Fez → Marrakech", "Fès → Marrakech"),
    group_b: T("Marrakech → Fez", "Marrakech → Fez", "Marrakech → Fès"),
  },
  programs: [
    { id: "fr-6-7",  direction: "a", nights: "6n7d",  accent: "#C16542", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourFezRak67",  blurb: BLURB_FR(6,7)("Fez","Marrakech") },
    { id: "fr-7-8",  direction: "a", nights: "7n8d",  accent: "#D97742", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourFezRak78",  blurb: BLURB_FR(7,8)("Fez","Marrakech") },
    { id: "fr-8-9",  direction: "a", nights: "8n9d",  accent: "#A07042", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourFezRak89",  blurb: BLURB_FR(8,9)("Fez","Marrakech") },
    { id: "fr-9-10", direction: "a", nights: "9n10d", accent: "#D4A373", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourFezRak910", blurb: BLURB_FR(9,10)("Fez","Marrakech") },
    { id: "rf-6-7",  direction: "b", nights: "6n7d",  accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez67",  blurb: BLURB_FR(6,7)("Marrakech","Fez") },
    { id: "rf-7-8",  direction: "b", nights: "7n8d",  accent: "#7C8B5C", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez78",  blurb: BLURB_FR(7,8)("Marrakech","Fez") },
    { id: "rf-8-9",  direction: "b", nights: "8n9d",  accent: "#A07042", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez89",  blurb: BLURB_FR(8,9)("Marrakech","Fez") },
    { id: "rf-9-10", direction: "b", nights: "9n10d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez910", blurb: BLURB_FR(9,10)("Marrakech","Fez") },
  ],
};

export const HUB_GRANSUR_FEZ_SIDIALI_RAK = {
  id: "gransur-fez-sidiali-rak",
  hero: {
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes por todo Marruecos", "Journeys across Morocco", "Voyages à travers le Maroc"),
    place: T("Fez · Medio Atlas · Sidi Ali · Erg Chebbi · Marrakech", "Fez · Middle Atlas · Sidi Ali · Erg Chebbi · Marrakech", "Fès · Moyen Atlas · Sidi Ali · Erg Chebbi · Marrakech"),
    title: T("Gran Sur + Medio Atlas.", "Grand South + Middle Atlas.", "Grand Sud + Moyen Atlas."),
    subtitle: T(
      "La travesía clásica ampliada con el Medio Atlas y el lago Aguelmame Sidi Ali — más profundidad, más contrastes.",
      "The classic crossing extended with the Middle Atlas and Aguelmame Sidi Ali lake — more depth, more contrasts.",
      "La traversée classique enrichie du Moyen Atlas et du lac Aguelmame Sidi Ali — plus de profondeur, plus de contrastes.",
    ),
  },
  intro: {
    overline: T("Fez – Sidi Ali – Marrakech", "Fez – Sidi Ali – Marrakech", "Fès – Sidi Ali – Marrakech"),
    title: T("El Medio Atlas se suma a la gran travesía.", "The Middle Atlas joins the great crossing.", "Le Moyen Atlas rejoint la grande traversée."),
    body: {
      es: [
        "Una versión más amplia y serena de la ruta clásica Fez – Marrakech.",
        "Se incorpora el Medio Atlas con su bosque de cedros gigantes, los pueblos de Azrou e Ifrane y el espectacular lago Aguelmame Sidi Ali, oasis alpino a 2.000 metros de altitud.",
        "El recorrido sigue después hacia el Erg Chebbi, la ruta de las mil kasbahs, el Alto Atlas y, finalmente, Marrakech.",
      ],
      en: [
        "A broader, more serene version of the classic Fez – Marrakech route.",
        "It adds the Middle Atlas with its giant cedar forest, the villages of Azrou and Ifrane and the spectacular Aguelmame Sidi Ali lake — an alpine oasis at 2,000 metres.",
        "The route then continues toward the Erg Chebbi, the route of a thousand kasbahs, the High Atlas and finally Marrakech.",
      ],
      fr: [
        "Une version plus ample et plus sereine de la route classique Fès – Marrakech.",
        "S'y ajoute le Moyen Atlas avec sa forêt de cèdres géants, les villages d'Azrou et Ifrane et le spectaculaire lac Aguelmame Sidi Ali, oasis alpin à 2 000 mètres.",
        "Le parcours continue ensuite vers l'Erg Chebbi, la route des mille kasbahs, le Haut Atlas et enfin Marrakech.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje del Gran Sur de Marruecos y Medio Atlas desde Fez hasta Marrakech", "Grand South + Middle Atlas options from Fez to Marrakech", "Options Grand Sud + Moyen Atlas, Fès à Marrakech"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on how many days you have for this journey.",
      "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    ),
    group_a: T("Fez → Sidi Ali → Marrakech", "Fez → Sidi Ali → Marrakech", "Fès → Sidi Ali → Marrakech"),
    group_b: T("Marrakech → Sidi Ali → Fez", "Marrakech → Sidi Ali → Fez", "Marrakech → Sidi Ali → Fès"),
  },
  programs: [
    { id: "fsm-7-8",  direction: "a", nights: "7n8d",  accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiRak78",  blurb: BLURB_SIDI(7,8)("Fez","Marrakech") },
    { id: "fsm-8-9",  direction: "a", nights: "8n9d",  accent: "#7C8B5C", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiRak89",  blurb: BLURB_SIDI(8,9)("Fez","Marrakech") },
    { id: "fsm-9-10", direction: "a", nights: "9n10d", accent: "#A07042", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiRak910", blurb: BLURB_SIDI(9,10)("Fez","Marrakech") },
    { id: "msf-7-8",  direction: "b", nights: "7n8d",  accent: "#C16542", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechSidialiFez78",  blurb: BLURB_SIDI(7,8)("Marrakech","Fez") },
    { id: "msf-8-9",  direction: "b", nights: "8n9d",  accent: "#D97742", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechSidialiFez89",  blurb: BLURB_SIDI(8,9)("Marrakech","Fez") },
    { id: "msf-9-10", direction: "b", nights: "9n10d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechSidialiFez910", blurb: BLURB_SIDI(9,10)("Marrakech","Fez") },
  ],
};

export const HUB_GRANSUR_OUARZA_FEZ = {
  id: "gransur-ouarzazate-sidiali-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes por todo Marruecos", "Journeys across Morocco", "Voyages à travers le Maroc"),
    place: T("Ouarzazate · Alto Atlas · Sahara · Sidi Ali · Fez", "Ouarzazate · High Atlas · Sahara · Sidi Ali · Fez", "Ouarzazate · Haut Atlas · Sahara · Sidi Ali · Fès"),
    title: T("Alto Atlas – Desierto – Fez.", "High Atlas – Desert – Fez.", "Haut Atlas – Désert – Fès."),
    subtitle: T(
      "De las cumbres del Atlas al laberinto de Fez, atravesando el Sahara y el oasis alpino de Sidi Ali.",
      "From the Atlas summits to the labyrinth of Fez, crossing the Sahara and the Sidi Ali alpine oasis.",
      "Des sommets de l'Atlas au labyrinthe de Fès, en traversant le Sahara et l'oasis alpine de Sidi Ali.",
    ),
  },
  intro: {
    overline: T("Ouarzazate – Sidi Ali – Fez", "Ouarzazate – Sidi Ali – Fez", "Ouarzazate – Sidi Ali – Fès"),
    title: T("Una ruta inversa, del Atlas hacia el norte imperial.", "A reverse route, from the Atlas to the imperial north.", "Un itinéraire inversé, de l'Atlas vers le nord impérial."),
    body: {
      es: [
        "La ruta arranca en Ouarzazate, capital del cine y puerta del Sahara, y se adentra en la ruta de las mil kasbahs hasta el Erg Chebbi.",
        "Tras la noche en el desierto, ascendemos al Medio Atlas con parada obligada en el lago Aguelmame Sidi Ali y el bosque de cedros gigantes.",
        "El viaje culmina en Fez, donde la medina viva más grande del mundo nos espera con sus zocos, sus tenerías y sus madrasas.",
      ],
      en: [
        "The route starts in Ouarzazate, capital of cinema and gateway to the Sahara, threading the route of a thousand kasbahs to the Erg Chebbi.",
        "After the desert night, we climb into the Middle Atlas with a mandatory stop at the Aguelmame Sidi Ali lake and the giant cedar forest.",
        "The journey culminates in Fez, where the world's largest living medina awaits with its souks, tanneries and madrasas.",
      ],
      fr: [
        "L'itinéraire débute à Ouarzazate, capitale du cinéma et porte du Sahara, et s'engage sur la route des mille kasbahs jusqu'à l'Erg Chebbi.",
        "Après la nuit au désert, nous montons dans le Moyen Atlas avec un arrêt obligatoire au lac Aguelmame Sidi Ali et à la forêt de cèdres géants.",
        "Le voyage culmine à Fès, où la plus grande médina vivante au monde nous attend avec ses souks, ses tanneries et ses médersas.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje del Alto Atlas desde Ouarzazate hasta Fez", "High Atlas options from Ouarzazate to Fez", "Options Haut Atlas, Ouarzazate à Fès"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on how many days you have for this journey.",
      "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    ),
    group_a: T("Ouarzazate → Sidi Ali → Fez", "Ouarzazate → Sidi Ali → Fez", "Ouarzazate → Sidi Ali → Fès"),
    group_b: T("Fez → Sidi Ali → Ouarzazate", "Fez → Sidi Ali → Ouarzazate", "Fès → Sidi Ali → Ouarzazate"),
  },
  programs: [
    { id: "of-5-6", direction: "a", nights: "5n6d", accent: "#A07042", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez56", blurb: BLURB_SIDI(5,6)("Ouarzazate","Fez") },
    { id: "of-6-7", direction: "a", nights: "6n7d", accent: "#D97742", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez67", blurb: BLURB_SIDI(6,7)("Ouarzazate","Fez") },
    { id: "of-7-8", direction: "a", nights: "7n8d", accent: "#C16542", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez78", blurb: BLURB_SIDI(7,8)("Ouarzazate","Fez") },
    { id: "fo-5-6", direction: "b", nights: "5n6d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOzz56", blurb: BLURB_SIDI(5,6)("Fez","Ouarzazate") },
    { id: "fo-6-7", direction: "b", nights: "6n7d", accent: "#7C8B5C", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOzz67", blurb: BLURB_SIDI(6,7)("Fez","Ouarzazate") },
    { id: "fo-7-8", direction: "b", nights: "7n8d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOuarzazate78", blurb: BLURB_SIDI(7,8)("Fez","Ouarzazate") },
  ],
};

export const HUB_GRANSUR_TANGER_RAK = {
  id: "gransur-tanger-rak",
  hero: {
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes por todo Marruecos", "Journeys across Morocco", "Voyages à travers le Maroc"),
    place: T("Tánger · Chefchaouen · Fez · Sahara · Marrakech", "Tangier · Chefchaouen · Fez · Sahara · Marrakech", "Tanger · Chefchaouen · Fès · Sahara · Marrakech"),
    title: T("Tánger – Marrakech.", "Tangier – Marrakech.", "Tanger – Marrakech."),
    subtitle: T(
      "Del Mediterráneo al desierto y del azul de Chefchaouen al rojo de Marrakech — la travesía más larga y completa.",
      "From the Mediterranean to the desert, from Chefchaouen blue to Marrakech red — the longest, most complete crossing.",
      "De la Méditerranée au désert, du bleu de Chefchaouen au rouge de Marrakech — la traversée la plus longue et complète.",
    ),
  },
  intro: {
    overline: T("Tánger – Marrakech", "Tangier – Marrakech", "Tanger – Marrakech"),
    title: T("La travesía total: norte, desierto y sur.", "The total crossing: north, desert and south.", "La traversée totale : nord, désert et sud."),
    body: {
      es: [
        "Una travesía completa que recorre Marruecos de norte a sur por la mítica ruta de las mil kasbahs.",
        "Comenzamos en Tánger, cruce de civilizaciones; continuamos hasta Chefchaouen, el pueblo azul del Rif, y descendemos a Fez para sumergirnos en la medina más antigua del mundo árabe.",
        "Después del Medio Atlas y el cedro gigante, el desierto del Erg Chebbi nos regala una noche bajo las estrellas.",
        "Cerramos en Marrakech, la ciudad roja, tras atravesar las gargantas del Todra, el Dades, Aït Benhaddou y el Alto Atlas por Tizi n'Tichka.",
      ],
      en: [
        "A full crossing of Morocco from north to south along the mythical route of a thousand kasbahs.",
        "We begin in Tangier, crossroads of civilisations; continue to Chefchaouen, the blue town of the Rif, and descend to Fez to enter the oldest medina in the Arab world.",
        "After the Middle Atlas and giant cedars, the Erg Chebbi desert grants us a night under the stars.",
        "We close in Marrakech, the red city, after crossing the Todra and Dades gorges, Aït Benhaddou and the High Atlas via Tizi n'Tichka.",
      ],
      fr: [
        "Une traversée complète du Maroc, du nord au sud, par la mythique route des mille kasbahs.",
        "Nous commençons à Tanger, carrefour des civilisations ; continuons jusqu'à Chefchaouen, la ville bleue du Rif, et descendons à Fès pour plonger dans la plus ancienne médina du monde arabe.",
        "Après le Moyen Atlas et les cèdres géants, le désert de l'Erg Chebbi nous offre une nuit sous les étoiles.",
        "Nous terminons à Marrakech, la ville rouge, après les gorges du Todra et du Dadès, Aït Benhaddou et le Haut Atlas par Tizi n'Tichka.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje de la ruta de las mil kasbahs desde Tánger hasta Marrakech", "Route of a thousand kasbahs options from Tangier to Marrakech", "Options route des mille kasbahs, Tanger à Marrakech"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on how many days you have for this journey.",
      "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    ),
    group_a: T("Tánger → Marrakech", "Tangier → Marrakech", "Tanger → Marrakech"),
  },
  programs: [
    { id: "tr-8-9",  direction: "a", nights: "8n9d",  accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourTangerRak89",  blurb: BLURB_KASBAH(8,9)("Tánger","Marrakech") },
    { id: "tr-9-10", direction: "a", nights: "9n10d", accent: "#5A7F9C", image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85", link: "tourTangerRak910", blurb: BLURB_KASBAH(9,10)("Tánger","Marrakech") },
  ],
};


/* ============================================================
   Norte de Marruecos · 2 hubs
============================================================ */

const BLURB_CI = (n, d) => ({
  es: `Viaje de ${n} noches y ${d} días descubriendo las ciudades imperiales de Marruecos.`,
  en: `A ${n}-night, ${d}-day journey through Morocco's imperial cities.`,
  fr: `Voyage de ${n} nuits et ${d} jours à la découverte des cités impériales du Maroc.`,
});
const BLURB_CI_RIF = (n, d) => ({
  es: `Viaje de ${n} noches y ${d} días descubriendo las ciudades imperiales y la región del Rif.`,
  en: `A ${n}-night, ${d}-day journey through the imperial cities and the Rif region.`,
  fr: `Voyage de ${n} nuits et ${d} jours, cités impériales et région du Rif.`,
});
const BLURB_FT = (n, d) => ({
  es: `Viaje de ${n} noches y ${d} días recorriendo Fez, Chefchaouen, Tetuán y Tánger.`,
  en: `A ${n}-night, ${d}-day journey through Fez, Chefchaouen, Tetouan and Tangier.`,
  fr: `Voyage de ${n} nuits et ${d} jours à travers Fès, Chefchaouen, Tétouan et Tanger.`,
});

export const HUB_NORTE_CIUDADES_IMPERIALES = {
  id: "norte-ciudades-imperiales",
  hero: {
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes al Norte de Marruecos", "Northern Morocco journeys", "Voyages au Nord du Maroc"),
    place: T("Marrakech · Fez · Meknès · Rabat", "Marrakech · Fez · Meknes · Rabat", "Marrakech · Fès · Meknès · Rabat"),
    title: T("Ciudades imperiales.", "Imperial cities.", "Cités impériales."),
    subtitle: T(
      "Rutas culturales con distintas ciudades históricas y, según el programa, la región del Rif.",
      "Cultural routes through historic cities and, depending on the programme, the Rif region.",
      "Circuits culturels entre cités historiques et, selon le programme, région du Rif.",
    ),
  },
  intro: {
    overline: T("Opciones de viaje Ciudades Imperiales de Marruecos", "Imperial Cities of Morocco · options", "Cités Impériales du Maroc · options"),
    title: T("Elige tu ruta entre ciudades históricas.", "Choose your route through historic cities.", "Choisissez votre itinéraire entre villes historiques."),
    body: {
      es: [
        "Cada programa combina distintas etapas del Marruecos cultural: consulta su recorrido para conocer exactamente qué ciudades visita.",
        "Rabat, Meknes, Fez y Marrakech fueron capitales históricas; algunas rutas añaden Chefchaouen y Tetuán en el Rif.",
        "Sus medinas, palacios, jardines y mercados permiten descubrir siglos de historia y la hospitalidad marroquí.",
      ],
      en: [
        "Each programme combines different cultural stops: check its itinerary for the exact cities visited.",
        "Rabat, Meknes, Fez and Marrakech were historic capitals; some routes add Chefchaouen and Tetouan in the Rif.",
        "Their medinas, palaces, gardens and markets reveal centuries of history and Moroccan hospitality.",
      ],
      fr: [
        "Chaque programme combine différentes étapes culturelles : consultez son itinéraire pour connaître les villes visitées.",
        "Rabat, Meknès, Fès et Marrakech furent des capitales historiques ; certains circuits ajoutent Chefchaouen et Tétouan dans le Rif.",
        "Leurs médinas, palais, jardins et marchés révèlent des siècles d'histoire et l'hospitalité marocaine.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje", "Travel options", "Options de voyage"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on how many days you have.",
      "Choisissez parmi les options selon le nombre de jours disponibles.",
    ),
    group_a: T("Ciudades Imperiales", "Imperial Cities", "Cités Impériales"),
    group_b: T("Ciudades Imperiales + Rif", "Imperial Cities + Rif", "Cités Impériales + Rif"),
  },
  programs: [
    { id: "ci-4-5",    direction: "a", nights: "4n5d", accent: "#A07042", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourCiudadesImperiales45",    blurb: BLURB_CI(4, 5) },
    { id: "ci-5-6",    direction: "a", nights: "5n6d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1564507004663-b6dfb3c824d5?auto=format&fit=crop&w=1800&q=85", link: "tourCiudadesImperiales56", blurb: { es: "De Casablanca a Fez con Rabat, Chefchaouen, Volubilis y Meknes.", en: "From Casablanca to Fez via Rabat, Chefchaouen, Volubilis and Meknes.", fr: "De Casablanca à Fès via Rabat, Chefchaouen, Volubilis et Meknès." } },
    { id: "cirf-6-7",  direction: "b", nights: "6n7d", accent: "#5A7F9C", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourCiudadesImperialesRif67", blurb: BLURB_CI_RIF(6, 7) },
    { id: "cirf-7-8",  direction: "b", nights: "7n8d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourCiudadesImperialesRif78", blurb: BLURB_CI_RIF(7, 8) },
  ],
};

export const HUB_NORTE_TANGER_FEZ = {
  id: "norte-tanger-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Viajes al Norte de Marruecos", "Northern Morocco journeys", "Voyages au Nord du Maroc"),
    place: T("Fez · Chefchaouen · Tetuán · Tánger", "Fez · Chefchaouen · Tetouan · Tangier", "Fès · Chefchaouen · Tétouan · Tanger"),
    title: T("Fez – Tánger.", "Fez – Tangier.", "Fès – Tanger."),
    subtitle: T(
      "Mar, montaña, medinas históricas y el famoso pueblo azul de Chefchaouen.",
      "Sea, mountain, historic medinas and the famous blue town of Chefchaouen.",
      "Mer, montagne, médinas historiques et le célèbre village bleu de Chefchaouen.",
    ),
  },
  intro: {
    overline: T("Opciones de viajes Tánger – Fez", "Tangier – Fez options", "Options Tanger – Fès"),
    title: T("Del Mediterráneo al laberinto de Fez.", "From the Mediterranean to the Fez labyrinth.", "De la Méditerranée au labyrinthe de Fès."),
    body: {
      es: [
        "Elige entre las distintas opciones según los días disponibles para descubrir el norte de Marruecos, combinando ciudades imperiales, pueblos del Rif y costas atlánticas y mediterráneas.",
        "Tanto Fez, Meknès, Volubilis, como Chefchaouen, Tetuán y Tánger destacan por ser ciudades únicas, cada una con su propia personalidad y atmósfera.",
        "Desde su impresionante arquitectura hasta sus vibrantes mercados y paisajes mediterráneos, estas ciudades permiten descubrir la enorme diversidad cultural del norte de Marruecos.",
      ],
      en: [
        "Pick between the options depending on the days available to discover northern Morocco — imperial cities, Rif villages, Atlantic and Mediterranean coasts.",
        "Fez, Meknes, Volubilis, Chefchaouen, Tetouan and Tangier each stand out as a unique city, with its own personality and atmosphere.",
        "From striking architecture to vibrant markets and Mediterranean landscapes, they reveal the immense cultural diversity of northern Morocco.",
      ],
      fr: [
        "Choisissez parmi les options selon le nombre de jours pour découvrir le nord du Maroc — cités impériales, villages du Rif, côtes atlantique et méditerranéenne.",
        "Fès, Meknès, Volubilis, Chefchaouen, Tétouan et Tanger : chacune unique, avec sa propre atmosphère.",
        "De l'architecture aux marchés et aux paysages méditerranéens, elles révèlent l'immense diversité culturelle du nord marocain.",
      ],
    },
  },
  options: {
    overline: T("Opciones de viaje", "Travel options", "Options de voyage"),
    title: T("Elige tu travesía.", "Choose your route.", "Choisissez votre itinéraire."),
    body: T(
      "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      "Pick between the options depending on the days available.",
      "Choisissez parmi les options selon les jours disponibles.",
    ),
    group_a: T("Fez → Tánger", "Fez → Tangier", "Fès → Tanger"),
    group_b: T("Tánger → Fez", "Tangier → Fez", "Tanger → Fès"),
  },
  programs: [
    { id: "ft-5-6", direction: "a", nights: "5n6d", accent: "#5A7F9C", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourFezTanger56", blurb: BLURB_FT(5, 6) },
    { id: "ft-6-7", direction: "a", nights: "6n7d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourFezTanger67", blurb: BLURB_FT(6, 7) },
    { id: "tf-4-5", direction: "b", nights: "4n5d", accent: "#A07042", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourTangerFez45", blurb: BLURB_FT(4, 5) },
    { id: "tf-5-6", direction: "b", nights: "5n6d", accent: "#5A7F9C", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourTangerFez56", blurb: BLURB_FT(5, 6) },
  ],
};

/* ============================================================
   Hub · Marrakech → Fez · "Rak → Fez" (Gran Sur en sentido inverso)
   ----
   Specifically dedicated to the reverse direction of the Gran Sur
   route. All 4 program detail pages already exist.
============================================================ */

const BLURB_RF = (n, d) => ({
  es: `Viaje de ${n} noches y ${d} días desde Marrakech hasta Fez.`,
  en: `${n}-night/${d}-day journey from Marrakech to Fez.`,
  fr: `Voyage de ${n} nuits et ${d} jours de Marrakech à Fès.`,
});

export const HUB_GRANSUR_RAK_FEZ = {
  id: "gransur-rak-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por todo Marruecos", en: "Journeys across Morocco", fr: "Voyages à travers le Maroc" },
    place: { es: "Marrakech · Aït Ben Haddou · Erg Chebbi · Medio Atlas · Fez", en: "Marrakech · Aït Ben Haddou · Erg Chebbi · Middle Atlas · Fez", fr: "Marrakech · Aït Ben Haddou · Erg Chebbi · Moyen Atlas · Fès" },
    title: { es: "Déjate sorprender por la magia del gran sur.", en: "Be amazed by the magic of the great south.", fr: "Laissez-vous surprendre par la magie du grand sud." },
    subtitle: {
      es: "La ruta de las mil kasbahs en sentido inverso — de Marrakech a Fez cruzando palmeras, cañones y dunas.",
      en: "The thousand-kasbahs route in reverse — from Marrakech to Fez crossing palm groves, canyons and dunes.",
      fr: "La route des mille kasbahs à l'envers — de Marrakech à Fès, à travers palmeraies, canyons et dunes.",
    },
  },
  intro: {
    overline: { es: "Marrakech – Fez", en: "Marrakech – Fez", fr: "Marrakech – Fès" },
    title: {
      es: "La ruta de las mil kasbahs.",
      en: "The road of a thousand kasbahs.",
      fr: "La route des mille kasbahs.",
    },
    body: {
      es: [
        "Probablemente una de las rutas más fascinantes que se puedan hacer en Marruecos.",
        "A medida que dejamos las montañas cubiertas de nieve del Alto Atlas, el paisaje va cambiando: palmerales, cañones, gargantas y valles coronados por kasbahs nos acompañan hasta llegar a las dunas del Gran Erg Chebbi.",
        "El círculo se cierra en Fez, la medina más antigua y mejor conservada del mundo árabe.",
      ],
      en: [
        "Arguably one of the most fascinating routes you can do in Morocco.",
        "As we leave the snow-capped High Atlas behind, the landscape changes: palm groves, canyons, gorges and valleys crowned with kasbahs accompany us all the way to the dunes of the Great Erg Chebbi.",
        "The circle closes in Fez, the oldest and best-preserved medina in the Arab world.",
      ],
      fr: [
        "Probablement l'une des routes les plus fascinantes que l'on puisse faire au Maroc.",
        "À mesure que nous laissons derrière nous les montagnes enneigées du Haut Atlas, le paysage change : palmeraies, canyons, gorges et vallées couronnées de kasbahs nous accompagnent jusqu'aux dunes du Grand Erg Chebbi.",
        "Le cercle se referme à Fès, la plus ancienne médina la mieux conservée du monde arabe.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje · ruta de las mil kasbahs · Marrakech → Fez", en: "Thousand-kasbahs options · Marrakech → Fez", fr: "Options route des mille kasbahs · Marrakech → Fès" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Marrakech → Fez", en: "Marrakech → Fez", fr: "Marrakech → Fès" },
  },
  programs: [
    { id: "mf-6-7",  direction: "a", nights: "6n7d",  accent: "#C16542", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez67",  blurb: BLURB_RF(6, 7) },
    { id: "mf-7-8",  direction: "a", nights: "7n8d",  accent: "#D97742", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez78",  blurb: BLURB_RF(7, 8) },
    { id: "mf-8-9",  direction: "a", nights: "8n9d",  accent: "#A07042", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez89",  blurb: BLURB_RF(8, 9) },
    { id: "mf-9-10", direction: "a", nights: "9n10d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourMarrakechFez910", blurb: BLURB_RF(9, 10) },
  ],
};

/* ============================================================
   Hub · Atlas – Desierto – Medio Atlas – Fez
   ----
   Bidirectional Ouarzazate ↔ Fez crossing through the desert and
   the Middle Atlas. The 6 program detail pages are not built yet —
   option CTAs land on the contact form (no `link:`).
============================================================ */

const BLURB_AF = (n, d, from, to) => ({
  es: `Viaje de ${n} noches y ${d} días desde ${from} hasta ${to} pasando por el desierto y el Medio Atlas.`,
  en: `${n}-night/${d}-day journey from ${from} to ${to} through the desert and the Middle Atlas.`,
  fr: `Voyage de ${n} nuits et ${d} jours de ${from} à ${to} à travers le désert et le Moyen Atlas.`,
});

export const HUB_ATLAS_DESIERTO_FEZ = {
  id: "atlas-desierto-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes por todo Marruecos", en: "Journeys across Morocco", fr: "Voyages à travers le Maroc" },
    place: { es: "Alto Atlas · Desierto · Medio Atlas · Fez", en: "High Atlas · Desert · Middle Atlas · Fez", fr: "Haut Atlas · Désert · Moyen Atlas · Fès" },
    title: { es: "Del Alto Atlas a Fez, atravesando el desierto.", en: "From the High Atlas to Fez, across the desert.", fr: "Du Haut Atlas à Fès, à travers le désert." },
    subtitle: {
      es: "Descubre el sur de Marruecos desde el Alto Atlas hasta Fez · salidas diarias durante todo el año.",
      en: "Discover southern Morocco from the High Atlas to Fez · daily departures all year round.",
      fr: "Découvrez le sud du Maroc du Haut Atlas à Fès · départs quotidiens toute l'année.",
    },
  },
  intro: {
    overline: { es: "Atlas – Desierto – Medio Atlas – Fez", en: "Atlas – Desert – Middle Atlas – Fez", fr: "Atlas – Désert – Moyen Atlas – Fès" },
    title: { es: "De cumbre a cumbre, atravesando el Sahara.", en: "From summit to summit, across the Sahara.", fr: "De sommet en sommet, à travers le Sahara." },
    body: {
      es: [
        "Una travesía completa del sur del país: desde las cumbres nevadas del Alto Atlas, las kasbahs del Valle del Dades y el desierto del Erg Chebbi, hasta los cedros gigantes del Medio Atlas y la medina UNESCO de Fez.",
        "El circuito se puede realizar en ambos sentidos — Ouarzazate → Fez o Fez → Ouarzazate — con 5, 6 o 7 noches en función del tiempo disponible.",
      ],
      en: [
        "A full crossing of southern Morocco: from the snow-capped peaks of the High Atlas, the kasbahs of the Dades Valley and the Erg Chebbi desert, to the giant cedars of the Middle Atlas and the UNESCO medina of Fez.",
        "The circuit can be done in either direction — Ouarzazate → Fez or Fez → Ouarzazate — with 5, 6 or 7 nights depending on time available.",
      ],
      fr: [
        "Une traversée complète du sud du Maroc : des sommets enneigés du Haut Atlas, des kasbahs de la Vallée du Dadès et du désert de l'Erg Chebbi, aux cèdres géants du Moyen Atlas et à la médina UNESCO de Fès.",
        "Le circuit peut s'effectuer dans les deux sens — Ouarzazate → Fès ou Fès → Ouarzazate — avec 5, 6 ou 7 nuits selon le temps disponible.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de viaje · Alto Atlas → Fez", en: "Options · High Atlas → Fez", fr: "Options · Haut Atlas → Fès" },
    title: { es: "Elige tu travesía.", en: "Choose your route.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Ouarzazate → Fez", en: "Ouarzazate → Fez", fr: "Ouarzazate → Fès" },
    group_b: { es: "Fez → Ouarzazate", en: "Fez → Ouarzazate", fr: "Fès → Ouarzazate" },
  },
  programs: [
    { id: "of-5-6", direction: "a", nights: "5n6d", accent: "#C16542", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez56", blurb: BLURB_AF(5, 6, "Ouarzazate", "Fez") },
    { id: "of-6-7", direction: "a", nights: "6n7d", accent: "#D97742", image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez67", blurb: BLURB_AF(6, 7, "Ouarzazate", "Fez") },
    { id: "of-7-8", direction: "a", nights: "7n8d", accent: "#A07042", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourOzzSidialiFez78", blurb: BLURB_AF(7, 8, "Ouarzazate", "Fez") },
    { id: "fo-5-6", direction: "b", nights: "5n6d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOzz56", blurb: BLURB_AF(5, 6, "Fez", "Ouarzazate") },
    { id: "fo-6-7", direction: "b", nights: "6n7d", accent: "#7C8B5C", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOzz67", blurb: BLURB_AF(6, 7, "Fez", "Ouarzazate") },
    { id: "fo-7-8", direction: "b", nights: "7n8d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1800&q=85", link: "tourFezSidialiOuarzazate78", blurb: BLURB_AF(7, 8, "Fez", "Ouarzazate") },
  ],
};

export const HUB_ESCAPADA_RAK_ERG_RAK = {
  id: "escapada-rak-erg-rak",
  hero: {
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Escapadas Marruecos", en: "Morocco short escapes", fr: "Escapades Maroc" },
    place: { es: "Marrakech · Atlas · Erg Chebbi · Marrakech", en: "Marrakech · Atlas · Erg Chebbi · Marrakech", fr: "Marrakech · Atlas · Erg Chebbi · Marrakech" },
    title: {
      es: "Escapadas de 3 a 5 días a Marrakech y al desierto del Erg Chebbi.",
      en: "Short 3 to 5-day escapes to Marrakech and the Erg Chebbi desert.",
      fr: "Escapades de 3 à 5 jours à Marrakech et au désert de l'Erg Chebbi.",
    },
    subtitle: {
      es: "Marrakech, puerta del Sáhara — pasa al menos una noche bajo las estrellas en las dunas del Erg Chebbi antes de volver a la ciudad roja.",
      en: "Marrakech, gateway to the Sahara — spend at least one night under the stars on the Erg Chebbi dunes before returning to the red city.",
      fr: "Marrakech, porte du Sahara — passez au moins une nuit sous les étoiles sur les dunes de l'Erg Chebbi avant de regagner la ville rouge.",
    },
  },
  intro: {
    overline: { es: "Marrakech – Erg Chebbi – Marrakech", en: "Marrakech – Erg Chebbi – Marrakech", fr: "Marrakech – Erg Chebbi – Marrakech" },
    title: {
      es: "Marrakech y el Sáhara, en pocas noches.",
      en: "Marrakech and the Sahara, in just a few nights.",
      fr: "Marrakech et le Sahara, en quelques nuits.",
    },
    body: {
      es: [
        "Marrakech, en el centro de Marruecos, sigue siendo uno de los destinos más populares del país: alberga monumentos imprescindibles como la Medina, la mezquita Koutoubia o la mítica plaza Jemaa el-Fna.",
        "Pero más allá de la ciudad, Marrakech es también la puerta de entrada al Sáhara y a las imponentes dunas del Erg Chebbi.",
        "Un viaje a Marruecos no está completo sin pasar al menos una noche durmiendo en el desierto, entre las dunas más altas del país.",
      ],
      en: [
        "Marrakech, in the centre of Morocco, remains one of the country's most popular destinations: home to landmarks like the Medina, the Koutoubia mosque and the legendary Jemaa el-Fna square.",
        "But beyond the city, Marrakech is also the gateway to the Sahara and the towering Erg Chebbi dunes.",
        "A trip to Morocco is not complete without at least one night sleeping in the desert, among the country's tallest dunes.",
      ],
      fr: [
        "Marrakech, au centre du Maroc, reste l'une des destinations les plus populaires du pays : médina, mosquée Koutoubia ou la mythique place Jemaa el-Fna.",
        "Mais au-delà de la ville, Marrakech est aussi la porte du Sahara et des dunes spectaculaires de l'Erg Chebbi.",
        "Un voyage au Maroc ne serait pas complet sans au moins une nuit dans le désert, parmi les plus hautes dunes du pays.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de escapada", en: "Short escape options", fr: "Options d'escapade" },
    title: { es: "Elige tu escapada.", en: "Choose your short escape.", fr: "Choisissez votre escapade." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this journey.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles.",
    },
    group_a: { es: "Marrakech → Erg Chebbi → Marrakech", en: "Marrakech → Erg Chebbi → Marrakech", fr: "Marrakech → Erg Chebbi → Marrakech" },
  },
  programs: [
    { id: "esc-mem-2-3", direction: "a", nights: "2n3d", accent: "#5A6B4F",
      image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85",
      link: "tourEscapadaRakErgRak23",
      blurb: { es: "Viaje de 2 noches y 3 días descubriendo Marrakech y el desierto del Erg Chebbi.",
               en: "2-night/3-day trip discovering Marrakech and the Erg Chebbi desert.",
               fr: "Voyage de 2 nuits et 3 jours pour découvrir Marrakech et le désert de l'Erg Chebbi." } },
    { id: "esc-mem-3-4", direction: "a", nights: "3n4d", accent: "#7C8B5C",
      image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1800&q=85",
      link: "tourEscapadaRakErgRak34",
      blurb: { es: "Viaje de 3 noches y 4 días descubriendo Marrakech y el desierto del Erg Chebbi, con noche extra en Kasbah Xaluca.",
               en: "3-night/4-day trip with Marrakech, the Erg Chebbi desert and an extra night at Kasbah Xaluca.",
               fr: "Voyage de 3 nuits et 4 jours avec Marrakech, l'Erg Chebbi et une nuit supplémentaire au Kasbah Xaluca." } },
    { id: "esc-mem-4-5", direction: "a", nights: "4n5d", accent: "#D97742",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourEscapadaRakErgRak45",
      blurb: { es: "Viaje de 4 noches y 5 días con día completo en el Alto Atlas Central y dos noches en Kasbah Xaluca antes del bivouac.",
               en: "4-night/5-day trip with a full Central High Atlas day and two nights at Kasbah Xaluca before the bivouac.",
               fr: "Voyage de 4 nuits et 5 jours avec une journée complète dans le Haut Atlas Central et deux nuits au Kasbah Xaluca." } },
  ],
};



/* ============================================================
   Escapadas cortas · hubs editoriales (Fez · Marrakech · Tánger)
   ----
   Estas escapadas se renderizan con EscapadaIntroPage (intro +
   contacto). Aquí solo se definen los hubs para programNav:
   activan breadcrumbs + HubPeerNav en las páginas de programa hijas.
============================================================ */
export const HUB_ESCAPADA_FEZ = {
  id: "escapada-fez",
  hero: {
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Escapadas por Marruecos", "Morocco short escapes", "Escapades au Maroc"),
    place: T("Fez · Meknés · Volubilis · Sidi Ali", "Fez · Meknes · Volubilis · Sidi Ali", "Fès · Meknès · Volubilis · Sidi Ali"),
    title: T("Escapada a Fez.", "Fez short escape.", "Escapade à Fès."),
    subtitle: T(
      "La capital espiritual de Marruecos en pocas noches — medina UNESCO, Meknés, Volubilis y el lago Aguelmame Sidi Ali.",
      "Morocco's spiritual capital in just a few nights — UNESCO medina, Meknes, Volubilis and Aguelmame Sidi Ali lake.",
      "La capitale spirituelle du Maroc en quelques nuits — médina UNESCO, Meknès, Volubilis et le lac Aguelmame Sidi Ali.",
    ),
  },
  intro: {
    overline: T("Escapada a Fez", "Fez short escape", "Escapade à Fès"),
    title: T("Elige tu escapada a Fez.", "Choose your Fez escape.", "Choisissez votre escapade à Fès."),
  },
  programs: [
    { id: "esc-fez-2-3", nights: "2n3d", accent: "#A07042", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaFez23",
      blurb: T("Fez en su esencia: dos noches en la medina UNESCO más antigua del mundo árabe.", "Fez at its purest: two nights in the oldest UNESCO medina in the Arab world.", "Fès à l'essentiel : deux nuits dans la plus ancienne médina UNESCO du monde arabe.") },
    { id: "esc-fez-3-4", nights: "3n4d", accent: "#5A6B4F", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaFez34",
      blurb: T("Fez ampliado con Meknés, Volubilis y Moulay Idriss — tres joyas imperiales en un solo viaje.", "Fez plus Meknes, Volubilis and Moulay Idriss — three imperial gems in one trip.", "Fès complété par Meknès, Volubilis et Moulay Idriss — trois joyaux impériaux en un seul voyage.") },
    { id: "esc-fs-3-4", nights: "3n4d", accent: "#5A7F9C", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaFezSidiali34",
      blurb: T("Fez y el Medio Atlas: Ifrane, los cedros centenarios y el lago Aguelmame Sidi Ali.", "Fez and the Middle Atlas: Ifrane, ancient cedars and Aguelmame Sidi Ali lake.", "Fès et le Moyen Atlas : Ifrane, les cèdres centenaires et le lac Aguelmame Sidi Ali.") },
    { id: "esc-fs-4-5", nights: "4n5d", accent: "#3A4A5F", image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaFezSidiali45",
      blurb: T("Fez, Meknés, Volubilis y el lago Sidi Ali — la escapada más completa del norte interior.", "Fez, Meknes, Volubilis and Sidi Ali lake — the most complete inland-north escape.", "Fès, Meknès, Volubilis et le lac Sidi Ali — l'escapade la plus complète du nord intérieur.") },
  ],
};

export const HUB_ESCAPADA_MARRAKECH = {
  id: "escapada-marrakech",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Escapadas por Marruecos", "Morocco short escapes", "Escapades au Maroc"),
    place: T("Marrakech · Agafay · pies del Atlas", "Marrakech · Agafay · foothills of the Atlas", "Marrakech · Agafay · pieds de l'Atlas"),
    title: T("Escapada a Marrakech.", "Marrakech short escape.", "Escapade à Marrakech."),
    subtitle: T(
      "La Ciudad Roja en pocas noches — Jemaa el-Fna, zocos y jardines, con opción de noche en el desierto de Agafay.",
      "The Red City in just a few nights — Jemaa el-Fna, souks and gardens, with the option of a night in the Agafay desert.",
      "La Ville Rouge en quelques nuits — Jemaa el-Fna, souks et jardins, avec option d'une nuit au désert d'Agafay.",
    ),
  },
  intro: {
    overline: T("Escapada a Marrakech", "Marrakech short escape", "Escapade à Marrakech"),
    title: T("Elige tu escapada a Marrakech.", "Choose your Marrakech escape.", "Choisissez votre escapade à Marrakech."),
  },
  programs: [
    { id: "esc-rak-2-3", nights: "2n3d", accent: "#D97742", image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaMarrakech23",
      blurb: T("Marrakech esencial: dos noches entre Jemaa el-Fna, zocos, palacios y jardines.", "Essential Marrakech: two nights amid Jemaa el-Fna, souks, palaces and gardens.", "Marrakech à l'essentiel : deux nuits entre Jemaa el-Fna, souks, palais et jardins.") },
    { id: "esc-raga-3-4", nights: "3n4d", accent: "#C16542", image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85", link: "tourEscapadaRakAgafay34",
      blurb: T("Marrakech + el desierto de Agafay: una noche bajo las estrellas a los pies del Atlas.", "Marrakech + the Agafay desert: a night under the stars at the foot of the Atlas.", "Marrakech + le désert d'Agafay : une nuit sous les étoiles au pied de l'Atlas.") },
  ],
};

export const HUB_ESCAPADA_TANGER = {
  id: "escapada-tanger",
  hero: {
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
    eyebrow: T("Escapadas por Marruecos", "Morocco short escapes", "Escapades au Maroc"),
    place: T("Tánger · Asilah · Tetuán · Chefchaouen", "Tangier · Asilah · Tetouan · Chefchaouen", "Tanger · Asilah · Tétouan · Chefchaouen"),
    title: T("Escapada a Tánger.", "Tangier short escape.", "Escapade à Tanger."),
    subtitle: T(
      "El norte entre dos mares — Tánger, Asilah, Tetuán y el pueblo azul de Chefchaouen.",
      "The north between two seas — Tangier, Asilah, Tetouan and the blue town of Chefchaouen.",
      "Le nord entre deux mers — Tanger, Asilah, Tétouan et le village bleu de Chefchaouen.",
    ),
  },
  intro: {
    overline: T("Escapada a Tánger", "Tangier short escape", "Escapade à Tanger"),
    title: T("Tu escapada al norte de Marruecos.", "Your northern Morocco escape.", "Votre escapade au nord du Maroc."),
  },
  programs: [],
};

/* ============================================================
   Hub · Aventura · Enduro por Marruecos
   ----
   Sub-hub of /viajes/aventura. Only the approved 3n/4d and 4n/5d programmes.
============================================================ */
export const HUB_AVENTURA_ENDURO = {
  id: "aventura-enduro",
  hero: {
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2400&q=85",
    eyebrow: { es: "Viajes de aventura · Sur de Marruecos", en: "Adventure trips · Southern Morocco", fr: "Voyages d'aventure · Sud du Maroc" },
    place: { es: "Erfoud · Tisserdimine · Erg Chebbi · Merzouga", en: "Erfoud · Tisserdimine · Erg Chebbi · Merzouga", fr: "Erfoud · Tisserdimine · Erg Chebbi · Merzouga" },
    title: { es: "Enduro por Marruecos.", en: "Enduro across Morocco.", fr: "Enduro au Maroc." },
    subtitle: {
      es: "Dos programas de 3 o 4 noches, con 2 o 3 días de moto con guía entre pistas, oasis y dunas del sur de Marruecos.",
      en: "Two programmes of 3 or 4 nights, with 2 or 3 guided riding days among tracks, oases and dunes in southern Morocco.",
      fr: "Deux programmes de 3 ou 4 nuits, avec 2 ou 3 jours à moto avec guide entre pistes, oasis et dunes du sud du Maroc.",
    },
  },
  intro: {
    overline: { es: "Enduro por Marruecos", en: "Enduro across Morocco", fr: "Enduro au Maroc" },
    title: {
      es: "Sigue las huellas de los pilotos dakarianos.",
      en: "Follow the tracks of the Dakar riders.",
      fr: "Suivez les traces des pilotes du Dakar.",
    },
    body: {
      es: [
        "Si te apasiona la aventura, el mundo del motor, la adrenalina y recorrer paisajes abiertos e infinitos, te proponemos una ruta por el sur de Marruecos para disfrutar de varios días sobre una moto de enduro, siguiendo las huellas de los auténticos pilotos dakarianos.",
        "Atravesarás pistas, oasis, dunas y pueblos bereberes mientras descubres algunos de los rincones más espectaculares del país.",
        "¡Las sensaciones que vivirás son indescriptibles!",
      ],
      en: [
        "If you are passionate about adventure, motors, adrenaline and crossing open, infinite landscapes, we propose a route in southern Morocco — several days on an enduro bike, following the tracks of the true Dakar pilots.",
        "You will cross tracks, oases, dunes and Berber villages while discovering some of the country's most spectacular corners.",
        "The sensations are simply indescribable.",
      ],
      fr: [
        "Si vous êtes passionné(e) d'aventure, de moto, d'adrénaline et de paysages ouverts à l'infini, nous vous proposons un itinéraire dans le sud du Maroc — plusieurs jours sur une moto d'enduro, dans les traces des vrais pilotes du Dakar.",
        "Vous traverserez pistes, oasis, dunes et villages berbères pour découvrir certains des coins les plus spectaculaires du pays.",
        "Les sensations vécues sont tout simplement indescriptibles.",
      ],
    },
  },
  options: {
    overline: { es: "Opciones de enduro por Marruecos", en: "Enduro options across Morocco", fr: "Options d'enduro au Maroc" },
    title: { es: "Elige tu travesía.", en: "Choose your ride.", fr: "Choisissez votre itinéraire." },
    body: {
      es: "Elige entre las distintas opciones en función de los días disponibles que tengas para realizar este viaje.",
      en: "Pick between the options depending on how many days you have for this trip.",
      fr: "Choisissez parmi les options selon le nombre de jours disponibles pour ce voyage.",
    },
    group_a: { es: "Aventura + Enduro", en: "Adventure + Enduro", fr: "Aventure + Enduro" },
  },
  programs: [
    {
      id: "enduro-3-4", direction: "a", nights: "3n4d", accent: "#C16542",
      image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=85",
      link: "tourEnduroAventura34",
      blurb: {
        es: "3 noches / 4 días · 2 días de moto con guía. Erfoud, Tisserdimine, Erg Chebbi y Merzouga.",
        en: "3 nights / 4 days · 2 guided riding days. Erfoud, Tisserdimine, Erg Chebbi and Merzouga.",
        fr: "3 nuits / 4 jours · 2 jours de moto avec guide. Erfoud, Tisserdimine, Erg Chebbi et Merzouga.",
      },
    },
    {
      id: "enduro-4-5", direction: "a", nights: "4n5d", accent: "#A07042",
      image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=85",
      link: "tourEnduroAventura45",
      blurb: {
        es: "4 noches / 5 días · 3 días de moto con guía. Oasis, Erg Chebbi y posibles visitas a Rissani y Khamlia.",
        en: "4 nights / 5 days · 3 guided riding days. Oases, Erg Chebbi and possible visits to Rissani and Khamlia.",
        fr: "4 nuits / 5 jours · 3 jours de moto avec guide. Oasis, Erg Chebbi et visites possibles de Rissani et Khamlia.",
      },
    },
  ],
};

/* ============================================================
   Hub registry + helper
   ------------------------------------------------------------
   Lets editorial gateway sections (Sur/Norte/Marruecos) resolve a
   hub's bookable programmes by id, so their "Desde €…" price equals
   the lowest real tariff of that hub — consistent with the hub page,
   the trip detail page and /precios.
============================================================ */
export const HUBS_BY_ID = [
  HUB_ATLAS_DESIERTO, HUB_DESIERTO_ATLAS, HUB_MARRAKECH_ERG, HUB_ERGCHEBBI_MARRAKECH,
  HUB_MARRAKECH_LOOP, HUB_MARRAKECH_ESSAOUIRA, HUB_ERRACHIDIA_ATLAS_FEZ, HUB_GRANSUR_FEZ_RAK,
  HUB_GRANSUR_FEZ_SIDIALI_RAK, HUB_GRANSUR_OUARZA_FEZ, HUB_GRANSUR_TANGER_RAK,
  HUB_NORTE_CIUDADES_IMPERIALES, HUB_NORTE_TANGER_FEZ, HUB_GRANSUR_RAK_FEZ,
  HUB_ATLAS_DESIERTO_FEZ, HUB_ESCAPADA_RAK_ERG_RAK,
  HUB_ESCAPADA_FEZ, HUB_ESCAPADA_MARRAKECH, HUB_ESCAPADA_TANGER, HUB_AVENTURA_ENDURO,
].reduce((acc, hub) => {
  if (hub && hub.id) acc[hub.id] = hub;
  return acc;
}, {});

export const hubProgramRouteIds = (hubId) =>
  ((HUBS_BY_ID[hubId] && HUBS_BY_ID[hubId].programs) || [])
    .map((p) => p.link)
    .filter(Boolean);
